import React from "react";
import { toast } from "react-toastify";
import { listOfSubscriptions } from "../../../../common/envConfig";
import { steps } from "../ModalAutoRenew";
import QuantityStepper from "../../../../components/shared/QuantityStepper";
import Spinner from "../../../../components/shared/spinner/Spinner";

const ApplyCredit = ({
  onClose,
  user,
  student,
  handleUpgradeStudent,
  handleCurrentStep,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [amountOfMonths, setAmountOfMonths] = React.useState(1);

  const applyCredit = async () => {
    try {
      setIsLoading(true);
      await handleUpgradeStudent({
        studentId: student?.id,
        coachId: user?.id,
        coachName: `${user?.firstName} ${user?.lastName}`,
        subPlan: listOfSubscriptions.STUDENT_LITE_MONTHLY,
        subPeriod: amountOfMonths,
        autoRenewal: student?.subscription?.autoRenewal,
      });
      setIsLoading(false);
      handleCurrentStep(steps.AUTO_RENEW);
    } catch (error) {
      toast.error("Failed to apply credit. Please try again later.");
    }
  };

  return (
    <>
      <div className="text-2xl font-bold text-black">
        Do you want to apply a student credit
        {student?.userName ? ` to ${student?.userName}` : ""}?
      </div>

      <div className="text-base text-grayTrue700 mt-2">
        Currently you have {user?.creditCount} available
      </div>

      <QuantityStepper
        className="mt-4"
        min={1}
        max={user?.creditCount}
        value={amountOfMonths}
        onIncrease={() => setAmountOfMonths((prev) => prev + 1)}
        onDecrease={() => setAmountOfMonths((prev) => prev - 1)}
      />

      <button
        disabled={isLoading}
        onClick={(e) => {
          e.stopPropagation();
          applyCredit();
        }}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500 mt-4"
      >
        {isLoading ? <Spinner color="primary500" size="sm" /> : "Apply credit"}
      </button>

      <button
        disabled={isLoading}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnGray100 mt-2"
      >
        Nevermind
      </button>
    </>
  );
};

export default ApplyCredit;
